import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/CustomSelect.scss";
import { FaCheck } from "react-icons/fa";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomSelect = ({ label, value, options, onChange, getLabel, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (val) => {
    onChange(val);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Get label to show as selected text
  const getDisplayLabel = (val) => {
    if (!val) return "Select";
    return getLabel ? getLabel(val) : val;
  };

  return (
    <div className="custom-select-wrapper" ref={dropdownRef}>
      <label>{label}</label>
      <div className="custom-select" onClick={() => {if (isDisabled) return; setIsOpen(!isOpen)}}>
        <span>{getDisplayLabel(value)}</span>
        <ExpandMoreIcon />
      </div>

      {isOpen && (
        <ul className="dropdown">
          {options.map((option, index) => {
            const optionLabel = getDisplayLabel(option);
            const isSelected =
              getDisplayLabel(value) === optionLabel;

            return (
              <li
                key={index}
                className={`option ${isSelected ? "selected" : ""}`}
                onClick={() => handleSelect(option)}
              >
                {isSelected && <FaCheck className="check-icon" />}
                {optionLabel}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
